document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.inspiration-archive__select').forEach(function (select) {
		select.addEventListener('change', function () {
			window.location.href = this.value;
		});
	});
});
